import { isGoogleCloudPlatform } from '@atlaskit/atlassian-context/cloud-provider';
import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { isIsolatedCloud } from '@atlaskit/atlassian-context/is-isolated-cloud';
import {
	ForgeCDNEnvironment,
	type ProductEnvironment,
} from '@atlassian/forge-ui-types/environments';

import { getCDNEnvironment } from './getCDNEnvironment';

export type HostMicrosEnv =
	| 'dev'
	| 'stg'
	| 'prod'
	| 'fedramp-stg'
	| 'fedramp-prod'
	| 'ic-stg'
	| 'ic-prod'
	| 'stg-gcentral'
	| 'prod-gcentral';

/**
 * Resolves the host product's Micros env for the Forge CDN from the product environment,
 * the cloud provider (GCP / AWS) and the perimeter (Isolated Cloud / FedRAMP).
 */
export const getHostMicrosEnv = (environment: ProductEnvironment): HostMicrosEnv => {
	const cdnEnv = getCDNEnvironment(environment);
	const isProd = cdnEnv === ForgeCDNEnvironment.PRODUCTION;

	// GCP, Isolated Cloud and FedRAMP are currently mutually exclusive.
	if (isGoogleCloudPlatform()) {
		// There is no dev-gcentral; dev maps to stg-gcentral.
		return isProd ? 'prod-gcentral' : 'stg-gcentral';
	} else if (isIsolatedCloud()) {
		return isProd ? 'ic-prod' : 'ic-stg';
	} else if (isFedRamp()) {
		return isProd ? 'fedramp-prod' : 'fedramp-stg';
	}

	// Commercial: 'dev' | 'stg' | 'prod'
	return cdnEnv;
};
